import { render } from "./ScienceGuideline.vue?vue&type=template&id=4f1d95aa&scoped=true"
import script from "./ScienceGuideline.vue?vue&type=script&lang=js"
export * from "./ScienceGuideline.vue?vue&type=script&lang=js"

import "./ScienceGuideline.vue?vue&type=style&index=0&id=4f1d95aa&scoped=true&lang=css"

import exportComponent from "/var/www/html/bcsprostuti-web-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f1d95aa"]])

export default __exports__